/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unstar_AriaInputs */

const en_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unstar Record`)
};

const fr_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer des favoris`)
};

const de_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unstar Record`)
};

const it_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record non contrassegnato`)
};

const ru_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unstar Record`)
};

const es_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro sin estrella`)
};

const zh_cn2_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不星唱片`)
};

const ja_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターなしレコード`)
};

const hi_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनस्टार रिकॉर्ड`)
};

const pt_pt2_explorer_info_unstar_aria = /** @type {(inputs: Explorer_Info_Unstar_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unstar Record`)
};

/**
* | output |
* | --- |
* | "Unstar Record" |
*
* @param {Explorer_Info_Unstar_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unstar_aria = /** @type {((inputs?: Explorer_Info_Unstar_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unstar_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_unstar_aria(inputs)
	if (locale === "de") return de_explorer_info_unstar_aria(inputs)
	if (locale === "it") return it_explorer_info_unstar_aria(inputs)
	if (locale === "ru") return ru_explorer_info_unstar_aria(inputs)
	if (locale === "es") return es_explorer_info_unstar_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_unstar_aria(inputs)
	if (locale === "ja") return ja_explorer_info_unstar_aria(inputs)
	if (locale === "hi") return hi_explorer_info_unstar_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_unstar_aria(inputs)
	return en_explorer_info_unstar_aria(inputs)
});